import { esc } from "./escape";
import {
  applyDesktopUpdate,
  dismissDesktopUpdate,
  getDesktopUpdateStatus,
  isDesktopHost,
} from "./host";
import { showToast } from "../components/ui";
import { router } from "../router";

const BANNER_ID = "desktop-update-banner";

export async function refreshDesktopUpdateBanner(): Promise<void> {
  const existing = document.getElementById(BANNER_ID);
  if (!isDesktopHost()) {
    existing?.remove();
    return;
  }

  const status = await getDesktopUpdateStatus(false);
  if (!status?.show_banner || !status.pending) {
    existing?.remove();
    return;
  }

  const pending = status.pending;
  const version = pending.version;
  let banner = existing;
  if (!banner) {
    banner = document.createElement("div");
    banner.id = BANNER_ID;
    banner.className = "update-banner";
    banner.setAttribute("role", "status");
    const header = document.querySelector(".app-header");
    if (header?.parentElement) {
      header.insertAdjacentElement("afterend", banner);
    } else {
      document.body.prepend(banner);
    }
  }

  const failed = Boolean(pending.apply_failed || status.apply_failed);
  banner.innerHTML = `
    <p class="update-banner-text">
      ${
        failed
          ? `<strong>Update failed:</strong> version ${esc(version)} did not install. Try again.`
          : `<strong>Update available:</strong> version ${esc(version)} is ready.`
      }
      ${pending.notes ? ` ${esc(pending.notes)}` : ""}
    </p>
    <div class="update-banner-actions">
      <button type="button" class="btn small" id="update-banner-apply">Update now</button>
      <button type="button" class="btn small secondary" id="update-banner-dismiss">Not now</button>
      <button type="button" class="btn small secondary" id="update-banner-details">Details</button>
    </div>`;

  banner.querySelector("#update-banner-details")?.addEventListener("click", () => {
    router.navigate("settings", "updates");
  });
  banner.querySelector("#update-banner-dismiss")?.addEventListener("click", async () => {
    await dismissDesktopUpdate(version);
    banner?.remove();
  });
  banner.querySelector("#update-banner-apply")?.addEventListener("click", async () => {
    const btn = banner?.querySelector("#update-banner-apply") as HTMLButtonElement | null;
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Downloading…";
    }
    const result = await applyDesktopUpdate();
    if (!result.ok) {
      showToast(result.error || "Update failed.", "error");
      if (btn) {
        btn.disabled = false;
        btn.textContent = "Update now";
      }
      await refreshDesktopUpdateBanner();
    }
  });
}
